// this is aliased in webpack config based on server/client build
import 'whatwg-fetch';
import { db } from '@/store/create-api';

function fetch(collection, reject) {
  console.log(`FETCHING:${collection}... ⬇️`);

  return new Promise((resolve) => {
    db.collection(collection).get().then((res) => {
      const val = res.docs;

      if (!val.every(bool => bool)) {
        reject();
        return;
      }

      console.log(`FETCHED:${collection} ✅`);

      resolve(val.map(v => v.data()));
    });
  });
}

export function fetchDoc(city) {
  const doc = `cities/${city}/data/${city}`;

  console.log(`FETCHING DATA:${doc}... ⬇️`);

  return new Promise((resolve) => {
    db.doc(doc).get().then((res) => {
      const val = res;

      console.log(`FETCHED:${doc} ✅`);

      resolve({ id: city, doc: val.data() });
    });
  });
}

export const fetchDocs = data => fetch(data);

export function fetchProjects(ids) {
  const promises = ids.map(el => fetch(`content/${el}`));

  return Promise.all([
    ...promises,
  ]);
}



// WEBPACK FOOTER //
// ./src/store/api.js